import { useMutation } from "@tanstack/react-query";
import Axios from "axios";

const useUserLetterPrinterMutation = ({ onSuccess }) => {
  return useMutation({
    mutationFn: ({ isNewLetterPrinted, isLetterPrinted, moveinInfoId }) => {
      return Axios.patch(
        `${process.env.REACT_APP_BASE_URL}/moveinInfo/letter-printed/${moveinInfoId}`,
        JSON.stringify(
          isNewLetterPrinted !== undefined
            ? { isNewLetterPrinted }
            : { isLetterPrinted }
        ),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem("token"),
          },
        }
      );
    },
    onSuccess,
  });
};

export default useUserLetterPrinterMutation;
